import { useState, useEffect } from 'react';

const features = [
  {
    icon: 'ri-spy-line',
    title: '独家内幕',
    desc: '深入娱乐圈幕后，挖掘不为人知的独家猛料，直击真相第一现场。',
    bgImage: 'https://readdy.ai/api/search-image?query=Dark%20abstract%20geometric%20composition%20with%20subtle%20neon%20green%20glow%20lines%2C%20mysterious%20and%20premium%20aesthetic%2C%20dark%20charcoal%20background%20with%20delicate%20light%20streaks%2C%20minimal%20editorial%20style%2C%20low%20key%20photography&width=800&height=800&seq=feature-01-exclusive&orientation=landscape',
  },
  {
    icon: 'ri-radar-line',
    title: '实时追踪',
    desc: '7×24小时不间断监控全网动态，热点事件秒级同步，绝不让你错过任何瓜。',
    bgImage: 'https://readdy.ai/api/search-image?query=Abstract%20radar%20wave%20pattern%20on%20dark%20background%20with%20acid%20green%20highlights%2C%20futuristic%20data%20visualization%20style%2C%20minimal%20and%20clean%20composition%2C%20dark%20atmosphere%20with%20glowing%20elements&width=800&height=800&seq=feature-02-realtime&orientation=landscape',
  },
  {
    icon: 'ri-vidicon-line',
    title: '高清视频',
    desc: '所有爆料视频支持高清在线播放，流畅不卡顿，沉浸式吃瓜体验。',
    bgImage: 'https://readdy.ai/api/search-image?query=Abstract%20cinematic%20lens%20flare%20on%20dark%20background%20with%20neon%20green%20accents%2C%20film%20strip%20abstract%20pattern%2C%20minimal%20composition%2C%20professional%20video%20production%20aesthetic%2C%20dark%20atmosphere&width=800&height=800&seq=feature-03-video&orientation=landscape',
  },
  {
    icon: 'ri-shield-check-line',
    title: '安全匿名',
    desc: '严格保护用户隐私，匿名浏览不留痕迹，放心吃瓜无后顾之忧。',
    bgImage: 'https://readdy.ai/api/search-image?query=Abstract%20shield%20and%20lock%20motif%20on%20dark%20background%20with%20subtle%20neon%20green%20accents%2C%20cybersecurity%20aesthetic%2C%20minimal%20and%20clean%20design%2C%20dark%20atmosphere%20with%20glowing%20edges&width=800&height=800&seq=feature-04-secure&orientation=landscape',
  },
  {
    icon: 'ri-refresh-line',
    title: '每日更新',
    desc: '日均更新上百条爆料资讯，内容覆盖明星、网红、社会事件等全方位吃瓜维度。',
    bgImage: 'https://readdy.ai/api/search-image?query=Abstract%20refresh%20and%20sync%20motion%20lines%20on%20dark%20background%20with%20acid%20green%20glow%2C%20digital%20flow%20pattern%2C%20minimal%20and%20dynamic%20composition%2C%20dark%20atmosphere%20with%20energetic%20accents&width=800&height=800&seq=feature-05-daily&orientation=landscape',
  },
];

export default function Features() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setVisible(true), 200);
    return () => clearTimeout(timer);
  }, []);

  return (
    <section id="features" className="relative py-20 md:py-28 px-4 md:px-8">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-14">
          <span className="inline-flex items-center gap-1.5 px-3 py-1 bg-accent-500/10 text-accent-400 text-xs font-semibold rounded-full border border-accent-500/20 whitespace-nowrap mb-4">
            <i className="ri-star-fill text-[10px]"></i>
            平台优势
          </span>
          <h2 className="text-3xl md:text-4xl font-extrabold text-foreground-50 tracking-tight">
            为什么选择 <span className="font-heading italic text-accent-400">51爆料网</span>
          </h2>
          <p className="text-foreground-400 text-sm mt-3 max-w-lg mx-auto">
            五大核心优势，打造全网最专业的吃瓜爆料平台
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 md:gap-5">
          {features.slice(0, 3).map((item, i) => (
            <div
              key={item.title}
              className={`group relative rounded-2xl overflow-hidden bg-background-100 border border-background-200/50 aspect-[4/3] transition-all duration-500 ${
                visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'
              }`}
              style={{ transitionDelay: `${i * 100}ms` }}
            >
              <img
                src={item.bgImage}
                alt={item.title}
                className="absolute inset-0 w-full h-full object-cover opacity-30 group-hover:opacity-40 transition-opacity duration-500"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-background-50 via-background-50/60 to-transparent"></div>
              <div className="relative z-10 flex flex-col items-center justify-center h-full text-center px-6">
                <span className="w-12 h-12 flex items-center justify-center rounded-xl bg-accent-500/15 text-accent-400 mb-4 group-hover:bg-accent-500/25 transition-colors">
                  <i className={`${item.icon} text-xl`}></i>
                </span>
                <h3 className="text-lg font-bold text-foreground-100 mb-2">{item.title}</h3>
                <p className="text-xs text-foreground-500 leading-relaxed">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 md:gap-5 mt-4 md:mt-5 max-w-2xl mx-auto">
          {features.slice(3, 5).map((item, i) => (
            <div
              key={item.title}
              className={`group relative rounded-2xl overflow-hidden bg-background-100 border border-background-200/50 aspect-[4/3] transition-all duration-500 ${
                visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'
              }`}
              style={{ transitionDelay: `${(i + 3) * 100}ms` }}
            >
              <img
                src={item.bgImage}
                alt={item.title}
                className="absolute inset-0 w-full h-full object-cover opacity-30 group-hover:opacity-40 transition-opacity duration-500"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-background-50 via-background-50/60 to-transparent"></div>
              <div className="relative z-10 flex flex-col items-center justify-center h-full text-center px-6">
                <span className="w-12 h-12 flex items-center justify-center rounded-xl bg-accent-500/15 text-accent-400 mb-4 group-hover:bg-accent-500/25 transition-colors">
                  <i className={`${item.icon} text-xl`}></i>
                </span>
                <h3 className="text-lg font-bold text-foreground-100 mb-2">{item.title}</h3>
                <p className="text-xs text-foreground-500 leading-relaxed">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}